import { css, palette } from 'bumbag';
import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var SideNav = {
  styles: {
    base: function base(props) {
      return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      background-color: ", ";\n    "])), palette('primary800')(props));
    }
  },
  Level: {
    Title: {
      styles: {
        base: function base(styleProps) {
          return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n          color: ", ";\n        "])), palette('white')(styleProps));
        }
      }
    }
  },
  Item: {
    styles: {
      base: function base(props) {
        return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        && {\n          color: ", " !important;\n          align-items: center;\n          border-color: ", ";\n          color: #e7e5e1;\n          display: flex;\n          height: 40px;\n          text-transform: uppercase;\n          text-decoration: none;\n\n          ", ";\n\n          &:hover {\n            background-color: ", ";\n            color: ", ";\n          }\n\n          &:focus {\n            outline: none;\n            background-color: ", ";\n          }\n        }\n      "])), palette('white')(props), palette('primary')(props), props.isActive && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n            background-color: ", ";\n            color: ", ";\n          "])), palette('primary700')(props), palette('white')(props)), palette('primary700')(props), palette('white')(props), palette('primary700')(props));
      }
    }
  }
};

export default SideNav;
